import React from "react";
import { Autocomplete } from "@material-ui/lab";
import { TextField } from "@material-ui/core";
import { ArrowDropDown } from "@material-ui/icons";

import { css } from "./styles";

export const SelectAutoComplete = (props) => {
    const styles = css();

    const { itens, disabled, onChange, label } = props;

    return (
        <Autocomplete
            id="fornecedorFilter"
            popupIcon={() => <ArrowDropDown style={{ display: "none" }} />}
            style={{ width: "447px" }}
            disabled={disabled ? disabled : false}
            options={itens}
            getOptionLabel={(o) => o.id + " - " + o.nome}
            onChange={onChange}
            loadingText="Carregando..."
            renderInput={(params) => (
                <>
                    <TextField
                        {...params}
                        className={styles.input}
                        variant="outlined"
                        label={label}
                        InputLabelProps={{ className: styles.label }}
                    />
                </>
            )}
        />
    );
};
